var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-btn',{attrs:{"href":'http://localhost:5001/jpi-core-web-vitals/us-central1/pingdom-pingdom',"target":"_blank"}},[_vm._v("local refresh")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }